// The site's one button arrow (the home hero's): an empty span the `button` recipe draws and
// stretches on hover. Use it as the last child of anything with the recipe class; `Button` /
// `LinkButton` render it for `arrow`.
export const ButtonArrow = ({ className }: { className?: string }) => (
  <span data-icon="end" data-arrow="" aria-hidden className={className} />
);
